import React, {useEffect, useState} from 'react'

import Dialog from "@material-ui/core/Dialog";
import get from 'lodash/get';
import Grid from "@material-ui/core/Grid";
import {Box, CircularProgress, Divider, Typography} from "@material-ui/core";
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import style from './loadingcomponent.module.css'
import {LOADING_SUCCESS_STATUS,LOADING_FAILURE_STATUS} from "./constants";

function LoadingComponent(props){
    const isDelay = get(props,"isDelay")
    const isLoading = get(props,"isLoading")

    const [loading,setLoading] = useState(false);
    const [canDelay,setCanDelay] = useState(false);

    // useEffect(()=>{
    //     setCanDelay(isDelay)
    // },[isDelay])

    useEffect(()=>{
        console.log("LoadingComponent isLoading",isLoading);
        // console.log("LoadingComponent canDelay",canDelay)
        // if(canDelay && isLoading === false){
        //     setCanDelay(false)
        //     setTimeout(() => {setLoading(isLoading);},30000)
        // }else{
            if(isDelay && isLoading === false ){
                setTimeout(() => {setLoading(isLoading);},2000)
            }else{
                setLoading(isLoading)
            }

        // }

    },[isLoading])

    const titleLabel = get(props,"titleLabel","Loading...")
    const status = get(props,"status")
    const subtitleLabel = get(props,"subtitleLabel","")


    const getStatus = ()=>{
        switch(status){
            case LOADING_SUCCESS_STATUS:
                return  <CheckCircleOutlinedIcon  className={style.app_loading_finished_icon}/>
            case LOADING_FAILURE_STATUS:
                return <ErrorOutlineOutlinedIcon  className={style.app_loading_error_icon}/>
            default:
               return  <CircularProgress size={"77px"} className={style.app_loading_icon}/>
        }
    }

    return (
        <Dialog
            open={loading}
            maxWidth={"sm"}
            fullWidth
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Divider className={style.app_loading_top_line} />
        <Grid container direction={"column"} alignItems={"center"} justify={"center"}  className={style.app_loading_grid_container}>
            <Grid item>
                <Box paddingBottom={"30px"}>

                    {getStatus()}
                </Box>

            </Grid>
            <Grid item >
               <Typography className={style.app_loading_status_label}>{titleLabel}</Typography>
            </Grid>
            <Grid item >
                <Typography className={style.app_loading_subtitle_label}>{subtitleLabel}</Typography>
            </Grid>
        </Grid>
        </Dialog>
    )
}

export default LoadingComponent;